import React from 'react';
import { connect } from "react-redux";
import './table.scss'
import Tabs from './tabs';
import Axios from 'axios'
import checkJwt from './../../../Global/jwtChecker'
import logout from './../../../Global/logout'

export class Main extends React.Component{

    state={
        loading: true,
        error: false,
        invoices: []
    }

    componentDidMount = async () => {
        document.title= "Računi"
        this.setState({
            loading: true
        })

        const unHashedJwt = await checkJwt()

        if(!unHashedJwt){
            logout()
        }

        await Axios( 'client/invoices', {
            method: 'get',
            headers: { 'Authorization' : unHashedJwt.data}           
        })
        .then(res => { 
            this.setState({
                invoices: res.data
            })
        })
        .catch(err => {
          if(err.response.status === 400){
              sessionStorage.clear();
              this.props.mapState("CLIENT_LOG_OUT")
              this.props.history.replace("/")
              //window.location = "/"
          }
        })

        
        this.setState({
            loading: false
        })

         
    }

    handleChange(e){
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    editClient(e){
        alert("Izvoz u PDF")
    }



    render(){  
        return(    
            <> 
             
            <main id="main_racuni" style={{height: "auto !important"}}>  
                    <header>
                        <h1>
                            Računi
                        </h1>
                    </header>

                    <div className="RacuniTable">              
                        <Tabs invoices={this.state.invoices}/>
                    </div>
               
            </main>
            
            </>
        )
    }  
}

const mapStateToProps = state => {
    return {
        userLoggedIn: state.client.userLoggedIn,
        asideToggled: state.clientSettings.asideToggled,
        jwtToken: state.client.jwtToken
    };
  };
  
  const mapDispatchToProps = dispatch => {
    return {
      mapState: (type, data) => dispatch({ type: type, data: data}),
      API: (type, data) => dispatch({ type: type, data: data})
    };
  };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Main);